var render, staticRenderFns
import script from "./select-option.vue?vue&type=script&lang=js&"
export * from "./select-option.vue?vue&type=script&lang=js&"
import style0 from "./select.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "select-option.vue"
export default component.exports